"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.omitDefault = omitDefault;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _long = require("./long");

function omitDefault(input) {
  if (typeof input === "string") {
    return input === "" ? undefined : input;
  }

  if (typeof input === "number") {
    return input === 0 ? undefined : input;
  }

  if (_long.Long.isLong(input)) {
    return input.isZero() ? undefined : input;
  }

  throw new Error("Got unsupported type ".concat((0, _typeof2["default"])(input)));
}